import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { taxId, conpanyName, releaseDate, representative, why, address, date },
} = checkout;

const validation = Yup.object().shape({
  [conpanyName.name]: Yup.string().required(conpanyName.errorMsg),
  [releaseDate.name]: Yup.string().required(releaseDate.errorMsg),
  [date.name]: Yup.string().required(date.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [why.name]: Yup.string().required(why.errorMsg),
  [representative.name]: Yup.string().required(representative.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
});

export default validation;
